import React from "react";
import { useCompleteProfile } from "@/context/CompleteProfileContext";
import CompleteProfileFooter from "../CompleteProfileFooter";
import SharedLifestyleSection from "@/components/shared/SharedLifestyleSection";
import { Wine } from "lucide-react";

const LifestyleStep = () => {
  const { data, updateData, autoSaveField, nextStep, saving } = useCompleteProfile();

  const handleUpdateData = (field: string, value: string) => {
    updateData({ [field]: value });
    autoSaveField(field, value); // Auto-save immediately on selection
  };

  // All fields required
  const canProceed = Boolean(data.smoker && data.drinker && data.piercings && data.tattoos && data.children);

  return (
    <CompleteProfileFooter
      buttonText="Continuar"
      onClick={nextStep}
      disabled={!canProceed}
      isLoading={saving}
    >
      <div className="space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 rounded-full bg-luxury-pinkBright/20 flex items-center justify-center mx-auto mb-4">
            <Wine className="w-8 h-8 text-luxury-pinkBright" />
          </div>
          <h2 className="text-2xl font-bold text-white">Estilo de Vida</h2>
          <p className="text-white/60 text-sm">
            Compartilhe seus hábitos e preferências
          </p>
        </div>

        {/* Form Fields */}
        <SharedLifestyleSection
          data={{
            smoker: data.smoker,
            drinker: data.drinker,
            piercings: data.piercings,
            tattoos: data.tattoos,
            children: data.children,
          }}
          updateData={handleUpdateData}
          isOnboarding={true}
          isEditing={true}
        />

        {/* Encouragement */}
        <div className="bg-white/5 border border-white/10 rounded-xl p-4 mt-6">
          <p className="text-sm text-white/70 text-center">
            🎯 Essas informações ajudam a encontrar pessoas compatíveis com você
          </p>
        </div>
      </div>
    </CompleteProfileFooter>
  );
};

export default LifestyleStep;
